/*
 * Aromely — Meta landing page (set) · classic script, no imports.
 * Deliberately NOT an ES module: Clarity recorded "@theme/component does not resolve"
 * errors on this URL, i.e. the theme's import map fails in some in-app browsers. This
 * file depends on nothing but the DOM and the Shopify cart endpoints, and the page sells
 * (server-rendered /cart/add form) even if this script never runs.
 */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var R = {
    add: root + 'cart/add.js',
    update: root + 'cart/update.js',
    cart: root + 'cart.js',
    discount: root + 'discount/'
  };

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function clarity(k, v) { try { if (window.clarity) window.clarity('set', k, String(v)); } catch (e) { /* ignore */ } }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function readJSON(el) { try { return JSON.parse(el.textContent || 'null'); } catch (e) { return null; } }
  function cookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/[.$?*|{}()[\]\\/+^]/g, '\\$&') + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }
  function money(cents, fmt) {
    var n = (Number(cents) || 0) / 100;
    var f = fmt || '${{amount}}';
    var withCommas = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return f
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace(/\{\{\s*amount\s*\}\}/g, withCommas);
  }

  function MetaSet(el) {
    this.el = el;
    this.fmt = el.dataset.moneyFormat || '${{amount}}';
    this.code = (el.dataset.code || '').trim();
    this.pct = parseInt(el.dataset.pct || '10', 10) || 0;
    this.proxy = (el.dataset.proxy || '').replace(/\/$/, '');
    this.diffusers = $$('[data-mlp-diffuser]', el).map(readJSON).filter(Boolean);
    this.scents = readJSON($('[data-mlp-scents]', el)) || [];
    this.model = null;
    this.vIdx = 0;
    this.slots = [];
    this.sub = false;
    this.codeApplied = false;
    this.fit = null;
    this.hvac = null;
    this.busy = false;
    this.reviewCache = {};
    this.init();
  }

  MetaSet.prototype.init = function () {
    var self = this;
    if (!this.diffusers.length) return;
    // slots from the server-rendered fragrance rows
    this.slots = $$('[data-mlp-slot]', this.el).map(function (row) {
      var pid = parseInt(row.getAttribute('data-product-id'), 10);
      return self.scents.find(function (s) { return s.product_id === pid; }) || null;
    });
    // model from the ad link
    var wanted = (new URL(location.href).searchParams.get('model') || '').toLowerCase().replace(/[^a-z0-9]/g, '');
    var m = this.diffusers.find(function (d) { return (d.key || '').replace(/[^a-z0-9]/g, '') === wanted; }) || this.diffusers[0];
    this.bind();
    this.setModel(m, false);
    this.preAnswerFit();
    this.detectCode();
    this.setupSticky();
    this.lazyReviews();
    this.promoObserver = new MutationObserver(function () { self.paintTotals(); });
    this.promoObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['data-promo'] });
    clarity('lp_variant', 'meta-set-v1');
  };

  /* ───────── helpers ───────── */
  MetaSet.prototype.variant = function () { return this.model.variants[this.vIdx] || this.model.variants[0]; };
  MetaSet.prototype.sizeFor = function (d) {
    var ml = Math.min(Number(d.favorite_ml) || 150, 150);
    return ml;
  };
  MetaSet.prototype.slotSize = function (scent) {
    if (!scent) return null;
    var want = this.sizeFor(this.model);
    var order = [want, 150, 120, 50, 500];
    for (var i = 0; i < order.length; i++) {
      var s = scent.sizes && scent.sizes[String(order[i])];
      if (s) return { ml: order[i], id: s.id, price: s.price, sub: s.sub || null };
    }
    return null;
  };
  MetaSet.prototype.sale = function () {
    var api = window.AromelyPromo;
    return api && api.active && api.active() && api.state && api.state.productCode && Number(api.state.pct) > 0 ? api.state : null;
  };
  MetaSet.prototype.salePrice = function (price) {
    var sale = this.sale();
    return sale ? price - Math.floor(price * sale.pct / 100) : price;
  };
  MetaSet.prototype.priceHTML = function (price) {
    var sale = this.sale();
    return (sale ? '<s class="mlp-price-was">' + esc(money(price, this.fmt)) + '</s> ' : '') + esc(money(this.salePrice(price), this.fmt));
  };
  MetaSet.prototype.totals = function () {
    var v = this.variant(), sale = this.sale();
    var separate = v.price, subSave = 0;
    var saleSave = sale ? Math.floor(v.price * sale.pct / 100) : 0;
    var qualifying = v.price - saleSave;
    var excluded = sale ? (sale.kit || []).concat(sale.backups || []).map(function (k) { return Number(k.productId); }) : [];
    if (excluded.indexOf(Number(this.model.product_id)) >= 0) qualifying = 0;
    var self = this;
    this.slots.forEach(function (sc) {
      var sz = self.slotSize(sc);
      if (!sz) return;
      var price = self.sub && sz.sub ? sz.sub.price : sz.price;
      separate += sz.price;
      subSave += Math.max(0, sz.price - price);
      if (excluded.indexOf(Number(sc.product_id)) < 0) qualifying += self.salePrice(price);
      if (sale) saleSave += Math.floor(price * sale.pct / 100);
    });
    var codeAmt = sale ? saleSave : this.code ? Math.floor((separate - subSave) * this.pct / 100) : 0;
    // Outside the event, account for the set code on the eligible share of the subtotal.
    if (!sale && codeAmt > 0 && separate > subSave) {
      qualifying = Math.max(0, qualifying - Math.ceil(codeAmt * qualifying / (separate - subSave)));
    }
    return { separate: separate, subSave: subSave, codeAmt: codeAmt, grand: separate - subSave - codeAmt, qualifying: qualifying };
  };

  /* ───────── rating (L02/L03) ───────── */
  MetaSet.prototype.paintRating = function (d) {
    var r = Number(d.rating) || 0, n = Number(d.reviews) || 0;
    $$('[data-mlp-rating]', this.el).forEach(function (e) { e.textContent = r ? r.toFixed(1) : '—'; });
    $$('[data-mlp-reviews]', this.el).forEach(function (e) { e.textContent = n.toLocaleString('en-US'); });
    // the five glyphs are filled proportionally (CSS gradient on --mlp-r), not always full
    $$('[data-mlp-stars]', this.el).forEach(function (e) { e.style.setProperty('--mlp-r', String(Math.max(0, Math.min(5, r)))); });
    $$('[data-mlp-rating-btn]', this.el).forEach(function (b) { b.setAttribute('aria-label', (r ? r.toFixed(1) + ' out of 5 stars from ' : '') + n.toLocaleString('en-US') + ' reviews — read them'); });
  };
  // Judge.me ids for a model (cached) — shared by the count and the review cards
  MetaSet.prototype.resolveJm = function (d) {
    var self = this, key = d.key;
    this.jmCache = this.jmCache || {};
    if (!this.jmCache[key]) {
      var ids = (d.review_group && d.review_group.length ? d.review_group : [d.product_id]);
      this.jmCache[key] = Promise.all(ids.map(function (id) { return fetch(self.proxy + '/api/products?external_id=' + id).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }))
        .then(function (rs) { return rs.map(function (x) { return x && x.product && x.product.id; }).filter(Boolean); });
    }
    return this.jmCache[key];
  };
  // Review count and rating come from Judge.me's product metafields (reviews.rating_count / reviews.rating) rendered
  // into the diffusers JSON — the same source as the collection cards, compare table and PDP hero. The proxy's count covers
  // only one listing, so it is not used here.

  /* ───────── model ───────── */
  MetaSet.prototype.setModel = function (d, pushUrl) {
    var self = this;
    this.model = d;
    this.vIdx = 0;
    var v = this.variant();
    // model picker
    $$('[data-mlp-model]', this.el).forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-mlp-model') === d.key)); });
    // stage
    var img = $('.mlp-hero-img', this.el);
    // the server already rendered diffusers[0] into the hero (with srcset) — rewriting it here downloaded the image twice
    var serverModel = !this.painted && d === this.diffusers[0];
    this.painted = true;
    if (img && d.hero && !serverModel) { img.src = d.hero; img.removeAttribute('srcset'); img.alt = d.hero_alt || d.name; }
    var stage = $('[data-mlp-stage]', this.el);
    var oldVideo = stage && $('video', stage);
    if (oldVideo) { oldVideo.remove(); var oldSnd = $('.mlp-stage__sound', stage); if (oldSnd) oldSnd.remove(); if (img) img.hidden = false; }
    var play = $('[data-mlp-play]', this.el);
    if (play) play.hidden = !d.video;
    // head
    var eyebrow = $('[data-mlp-eyebrow]', this.el);
    if (eyebrow) eyebrow.textContent = d.name + ' · ' + (d.rooms || ('up to ' + d.coverage.toLocaleString() + ' sq ft'));
    var h1 = $('[data-mlp-h1]', this.el);
    if (h1 && d.hook) h1.textContent = d.hook;
    var sub = $('[data-mlp-subline]', this.el);
    if (sub && d.sub) sub.textContent = d.sub;
    this.paintRating(d);
    // card
    var cimg = $('[data-mlp-card-img]', this.el); if (cimg) cimg.src = v.image || d.hero;
    var cname = $('[data-mlp-card-name]', this.el); if (cname) cname.textContent = d.name;
    var cline = $('[data-mlp-card-line]', this.el);
    if (cline) cline.innerHTML = esc(d.rooms || ('Up to ' + d.coverage.toLocaleString() + ' sq ft')) + ' · <span data-mlp-card-price>' + esc(money(v.price, this.fmt)) + '</span>';
    // swatches
    var colors = $('[data-mlp-colors]', this.el), sw = $('[data-mlp-swatches]', this.el);
    var multi = d.variants.length > 1 && d.variants[0].title !== 'Default Title';
    if (colors) colors.hidden = !multi;
    if (sw) {
      sw.innerHTML = multi ? d.variants.map(function (vv, i) {
        var c = vv.swatch.indexOf('black') >= 0 ? '#1a1a1a' : vv.swatch.indexOf('white') >= 0 ? '#f2f2f2' : vv.swatch.indexOf('silver') >= 0 ? '#c9c9c9' : '#a89f91';
        return '<button type="button" data-mlp-v="' + i + '" aria-label="' + esc(vv.title) + '" aria-pressed="' + (i === 0) + '" style="background:' + c + '"' + (vv.available ? '' : ' disabled') + '></button>';
      }).join('') : '';
      var cn = $('[data-mlp-color-name]', this.el); if (cn) cn.textContent = multi ? v.title : '';
    }
    // inputs + slots + totals
    var inp = $('[data-mlp-input-diffuser]', this.el); if (inp) inp.value = v.id;
    this.slots.forEach(function (sc, i) { self.paintSlot(i); });
    this.paintSub();
    this.paintTotals();
    this.paintPromoOffer();
    // box + steps + faq
    var bn = $('[data-mlp-box-name]', this.el); if (bn) bn.textContent = d.name;
    var bt = $('[data-mlp-box-tank]', this.el); if (bt) bt.textContent = d.tank_ml + ' ml bottle inside';
    var bk = $('[data-mlp-box-kit]', this.el); if (bk && d.box) bk.textContent = d.box;
    var bo = $('[data-mlp-box-oils]', this.el); if (bo) bo.textContent = '2 × ' + this.sizeFor(d) + ' ml fragrances';
    var sh = $('[data-mlp-steps-head]', this.el);
    if (sh) sh.textContent = d.hvac ? 'Three steps. A drill only if you connect it to your HVAC.' : 'Three steps. No tools.';
    var s2 = $('[data-mlp-step2]', this.el), s2t = $('[data-mlp-step2-text]', this.el);
    if (s2 && s2t) {
      if (d.hvac) { s2.textContent = 'Place it or connect it'; s2t.textContent = 'Stand it where you want it, or connect it to your air supply so the system carries the scent — the connection kit is in the box.'; }
      else if (d.form_factor === 'plug-in') { s2.textContent = 'Plug it in'; s2t.textContent = 'It plugs straight into the wall in the room you want to scent. No mount, no cables.'; }
      else { s2.textContent = 'Place it'; s2t.textContent = 'Stand it where the air moves — near a doorway or an open space — and it fills the area on its own.'; }
    }
    var faqdb = $('[data-mlp-faq-db]', this.el);
    if (faqdb) faqdb.textContent = d.db ? ('The ' + d.name + ' runs at about ' + d.db + ' dB at maximum — about as loud as a quiet library — and most people run it far below maximum.') : ('Noise depends on the intensity you set — most people run the ' + d.name + ' far below maximum.');
    var rh = $('[data-mlp-rev-head]', this.el); if (rh) rh.textContent = d.name;
    var ar = $('[data-mlp-all-reviews]', this.el); if (ar) ar.href = d.url + '#aromely-reviews-section';
    var soloN = $('[data-mlp-solo-name]', this.el); if (soloN) soloN.textContent = d.name;
    var soloP = $('[data-mlp-solo-price]', this.el); if (soloP) soloP.textContent = money(v.price, this.fmt);
    // url + clarity
    if (pushUrl !== false) {
      try { var u = new URL(location.href); u.searchParams.set('model', d.key); history.replaceState(history.state, '', u); } catch (e) { /* ignore */ }
    }
    clarity('model', d.key);
    if (this.reviewsVisible) this.loadReviews($('[data-mlp-revs]', this.el));
  };

  MetaSet.prototype.setVariant = function (i) {
    this.vIdx = i;
    var v = this.variant();
    $$('[data-mlp-v]', this.el).forEach(function (b) { b.setAttribute('aria-pressed', String(parseInt(b.getAttribute('data-mlp-v'), 10) === i)); });
    var cn = $('[data-mlp-color-name]', this.el); if (cn) cn.textContent = v.title;
    var cimg = $('[data-mlp-card-img]', this.el); if (cimg && v.image) cimg.src = v.image;
    var img = $('.mlp-hero-img', this.el); if (img && v.image) { img.src = v.image; img.removeAttribute('srcset'); }
    var inp = $('[data-mlp-input-diffuser]', this.el); if (inp) inp.value = v.id;
    this.paintTotals();
    this.paintPromoOffer();
  };

  MetaSet.prototype.paintPromoOffer = function () {
    var offer = $('[data-mlp-set-offer]', this.el), sale = this.sale();
    if (!offer || !sale) return;
    var total = this.totals();
    var qualify = Number(sale.qualifyCents) || Number(offer.dataset.qualify);
    var left = Math.max(0, qualify - total.qualifying);
    var title = offer.dataset.kitTitle || '5 free 20ml fragrance bottles';
    offer.textContent = left ? 'Get ' + title + ' on qualifying orders. Add ' + money(left, this.fmt) + ' after discounts to qualify. Gift eligibility is confirmed in your cart.' : 'This set can qualify for ' + title + '. Gift eligibility is confirmed after all discounts in your cart.';
  };

  MetaSet.prototype.paintSlot = function (i) {
    var row = $('[data-mlp-slot="' + i + '"]', this.el);
    var sc = this.slots[i];
    if (!row || !sc) return;
    var sz = this.slotSize(sc);
    row.setAttribute('data-product-id', sc.product_id);
    var img = $('[data-slot-img]', row); if (img && sc.image) img.src = sc.image;
    var nm = $('[data-slot-name]', row); if (nm) nm.textContent = sc.name;
    var line = $('[data-slot-line]', row);
    if (line) line.innerHTML = (sz ? sz.ml + 'ml' : '') + (sc.sub ? ' · ' + esc(sc.sub) : '') + (sz ? ' · <span data-slot-price>' + esc(money(sz.price, this.fmt)) + '</span>' : '');
    var notes = $('[data-slot-notes]', row);
    if (notes) notes.innerHTML = (sc.notes || []).slice(0, 4).map(function (n) { return '<span>' + esc(n) + '</span>'; }).join('');
    var inp = $('[data-slot-input]', row); if (inp && sz) inp.value = sz.id;
  };

  MetaSet.prototype.paintSub = function () {
    var self = this;
    var opt = $('[data-mlp-sub-opt]', this.el);
    if (!opt) return;
    var subs = this.slots.map(function (sc) { var sz = self.slotSize(sc); return sz && sz.sub; });
    var all = subs.length && subs.every(Boolean);
    opt.hidden = !all;
    if (!all) { this.sub = false; var cb = $('[data-mlp-sub]', this.el); if (cb) cb.checked = false; return; }
    var save = 0, base = 0;
    subs.forEach(function (s, i) { var sz = self.slotSize(self.slots[i]); base += sz.price; save += Math.max(0, sz.price - s.price); });
    var pctSave = base ? Math.round(save / base * 100) : 0;
    var t = $('[data-mlp-sub-text]', this.el);
    if (t) t.textContent = 'save ' + pctSave + '% on the two bottles (' + esc(subs[0].name || 'recurring delivery') + '); skip or cancel any time.';
  };

  MetaSet.prototype.paintTotals = function () {
    var t = this.totals(), sale = this.sale(), self = this;
    var set = function (sel, txt) { var e = $(sel, this.el); if (e) e.textContent = txt; }.bind(this);
    set('[data-mlp-separate]', money(t.separate, this.fmt));
    var cl = $('[data-mlp-code-line]', this.el); if (cl) cl.hidden = !this.code;
    set('[data-mlp-code-amt]', '−' + money(t.codeAmt, this.fmt));
    var sl = $('[data-mlp-sub-line]', this.el); if (sl) sl.hidden = !(this.sub && t.subSave > 0);
    set('[data-mlp-sub-amt]', '−' + money(t.subSave, this.fmt));
    set('[data-mlp-grand]', money(t.grand, this.fmt));
    set('[data-mlp-total-label]', sale ? 'Today with ' + sale.productCode : 'Today');
    set('[data-mlp-sale-amt]', '−' + money(t.codeAmt, this.fmt));
    var cardPrice = $('[data-mlp-card-price]', this.el); if (cardPrice) cardPrice.innerHTML = this.priceHTML(this.variant().price);
    set('[data-mlp-solo-price]', money(this.salePrice(this.variant().price), this.fmt));
    $$('[data-mlp-model]', this.el).forEach(function (button) {
      var model = self.diffusers.find(function (d) { return d.key === button.dataset.mlpModel; });
      var price = $('[data-mlp-model-price]', button);
      if (model && price) price.textContent = money(self.salePrice(model.variants[0].price), self.fmt);
    });
    this.slots.forEach(function (sc, i) {
      var sz = self.slotSize(sc), row = $('[data-mlp-slot="' + i + '"]', self.el);
      var price = row && $('[data-slot-price]', row);
      if (price && sz) price.innerHTML = self.priceHTML(self.sub && sz.sub ? sz.sub.price : sz.price);
    });
    this.paintPromoOffer();
    set('[data-mlp-add-label]', 'Add set to cart · ' + money(t.grand, this.fmt));
    set('[data-mlp-sticky-price]', money(t.grand, this.fmt));
    var free = parseInt(this.el.dataset.shipFree || '0', 10);
    var usd = (this.el.dataset.currency || 'USD') === 'USD';
    var label = this.el.dataset.shipLabel || ('$' + Math.round(free / 100));
    var shipTxt = free ? ((usd && t.grand >= free) ? 'Free U.S. shipping on this set' : 'Free U.S. shipping over ' + label) : '';
    if (shipTxt) $$('[data-mlp-ship]', this.el).forEach(function (e) { e.textContent = shipTxt; });
    set('[data-mlp-sticky-label]', this.model.name + ' set' + (sale ? ' · ' + sale.pct + '% off with ' + sale.productCode : this.code ? ' · ' + this.pct + '% ' + (this.codeApplied ? 'applied' : 'at checkout') : ''));
  };

  /* ───────── fit (R9) ───────── */
  MetaSet.prototype.recommend = function (kind, hvac) {
    // Commercial units (ARO MAX) sit in the picker but never get recommended for a home.
    var ds = this.diffusers.filter(function (d) { return !d.commercial; });
    var byCov = function (a, b) { return b.coverage - a.coverage; };
    var pick, alt, why;
    if (kind === 'room') {
      var small = ds.filter(function (d) { return !d.hvac && d.coverage <= 1000; }).sort(byCov);
      pick = small[0]; alt = small.find(function (d) { return d.coverage < (pick ? pick.coverage : 0); });
      why = pick ? pick.name + ' is built for one room or a small apartment — up to ' + pick.coverage.toLocaleString() + ' sq ft. A bigger unit here would be more than you need.' : '';
      if (alt) why += ' For a single small room, ' + alt.name + ' (up to ' + alt.coverage.toLocaleString() + ' sq ft) is the lighter option.';
    } else if (kind === 'home' && hvac === 'yes') {
      var hv = ds.filter(function (d) { return d.hvac; }).sort(byCov);
      pick = hv[0]; alt = hv[1];
      why = pick ? (this.el.dataset.hvacCopy || (pick.name + ' connects to your air supply so the system carries the scent to every room.')) : '';
      if (alt) why += ' Home under ' + alt.coverage.toLocaleString() + ' sq ft? ' + (alt === this.model ? 'Your ' + alt.name + ' does the same job — keep it.' : alt.name + ' does the same job for less.');
    } else if (kind === 'home' && hvac === 'no') {
      // every model runs standalone, HVAC-capable ones included — never exclude them here
      var st = ds.filter(function (d) { return d.standalone !== false; }).sort(byCov);
      pick = st[0]; alt = st.find(function (d) { return d.coverage < pick.coverage && d.coverage >= 1500; });
      why = pick ? 'Without central air the scent travels on its own, so it fills open, connected space best — ' + pick.name + ' has the most reach, up to ' + pick.coverage.toLocaleString() + ' sq ft. Closed-off rooms may each want their own unit.' : '';
      if (alt) why += ' Home under ' + alt.coverage.toLocaleString() + ' sq ft? ' + (alt === this.model ? 'Your ' + alt.name + ' is enough — keep it.' : alt.name + ' is enough.');
    } else if (kind === 'open') {
      var fl = ds.filter(function (d) { return d.form_factor === 'floor-tower'; }).sort(byCov);
      pick = fl[0] || ds.filter(function (d) { return !d.hvac; }).sort(byCov)[0];
      why = pick ? pick.name + ' stands on the floor and fills a large open area — a lobby, studio or open-plan living space — up to ' + pick.coverage.toLocaleString() + ' sq ft, with no HVAC connection needed.' : '';
    }
    return { pick: pick, alt: alt, why: why };
  };

  MetaSet.prototype.preAnswerFit = function () {
    var d = this.model;
    // a commercial unit is never a recommendation, so a pre-answer would talk its visitor down to a home model
    if (d.commercial) {
      this.fit = null; this.hvac = null;
      $$('[data-mlp-fit-opt], [data-mlp-hvac-opt]', this.el).forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      var hv = $('[data-mlp-hvac]', this.el); if (hv) hv.hidden = true;
      var ans = $('[data-mlp-fit-ans]', this.el); if (ans) ans.hidden = true;
      return;
    }
    var kind = d.hvac ? 'home' : d.form_factor === 'floor-tower' ? 'open' : 'room';
    this.answerFit(kind, d.hvac ? 'yes' : null, true);
  };

  MetaSet.prototype.answerFit = function (kind, hvac, silent) {
    var self = this;
    this.fit = kind; this.hvac = hvac;
    if (!silent) this.fitByUser = true; // a pre-answered fit belongs to the model, an answered one to the visitor
    $$('[data-mlp-fit-opt]', this.el).forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-mlp-fit-opt') === kind)); });
    var hv = $('[data-mlp-hvac]', this.el);
    if (hv) hv.hidden = kind !== 'home';
    $$('[data-mlp-hvac-opt]', this.el).forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-mlp-hvac-opt') === hvac)); });
    var ans = $('[data-mlp-fit-ans]', this.el);
    if (!ans) return;
    if (kind === 'home' && !hvac) { ans.hidden = false; ans.innerHTML = '<b>One more thing:</b> does your home have central air (a furnace or AC with vents)? It decides between the HVAC models and the standalone ones.'; return; }
    var r = this.recommend(kind, hvac);
    if (!r.pick) { ans.hidden = true; return; }
    var v = r.pick.variants[0];
    if (r.pick === this.model) {
      ans.innerHTML = '<b>Good fit.</b> ' + esc(r.why);
    } else {
      var cheaper = v.price < this.variant().price;
      var head = (kind === 'home' && hvac === 'yes' && !this.model.hvac) ? 'This one connects to your air system.' : r.pick.coverage < this.model.coverage ? 'Honest answer: you need less.' : r.pick.coverage > this.model.coverage ? 'You’ll want more reach.' : 'A better fit for your space.';
      ans.innerHTML = '<b>' + head + '</b> ' + esc(r.why) +
        '<button type="button" class="mlp-btn mlp-btn--sm" data-mlp-switch="' + esc(r.pick.key) + '">Switch my set to ' + esc(r.pick.name) + ' · ' + esc(money(this.salePrice(v.price), this.fmt)) + '</button>';
      if (!silent) clarity('step_down', cheaper ? 'offered' : 'up');
    }
    ans.hidden = false;
    if (!silent) clarity('fit_answer', kind + (hvac ? '-' + hvac : ''));
  };

  /* ───────── discount (R5) ───────── */
  MetaSet.prototype.detectCode = function () {
    if (!this.code) return;
    var self = this;
    var seen = (cookie('discount_code') || '').toLowerCase() === this.code.toLowerCase();
    var paint = function (on) {
      self.codeApplied = on;
      var box = $('[data-mlp-code]', self.el);
      if (box) {
        box.dataset.state = on ? 'on' : 'off';
        var t = $('[data-mlp-code-text]', box);
        if (t) t.textContent = on ? ('✓ ' + self.code + ' applied — nothing to type at checkout') : (self.code + ' — tap to apply your ' + self.pct + '% (or it’s already on your link)');
      }
      self.paintTotals();
      clarity('discount_applied', on ? 'y' : 'n');
    };
    if (seen) { paint(true); return; }
    fetch(R.cart, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var codes = (cart && cart.discount_codes) || [];
      paint(codes.some(function (c) { return (c.code || '').toLowerCase() === self.code.toLowerCase(); }));
    }).catch(function () { paint(false); });
  };

  MetaSet.prototype.applyCode = function () {
    if (this.sale() || !this.code || this.applying) return;
    var self = this, back = location.pathname + location.search;
    var url = R.discount + encodeURIComponent(this.code) + '?redirect=' + encodeURIComponent(back);
    clarity('discount_tap', 'y');
    this.applying = true;
    var box = $('[data-mlp-code]', this.el), btn = box && $('button', box); if (btn) { btn.disabled = true; btn.textContent = 'Applying…'; }
    // /discount/CODE sets the discount_code cookie; fetching it keeps the shopper on the page instead of a full reload
    fetch(url, { credentials: 'same-origin', redirect: 'follow' }).catch(function () { /* fall through */ }).then(function () {
      self.applying = false;
      if (btn) { btn.disabled = false; btn.textContent = 'Apply my ' + self.pct + '%'; }
      if ((cookie('discount_code') || '').toLowerCase() === self.code.toLowerCase()) { self.detectCode(); return; }
      location.href = url; // cookie not readable here — the redirect route still applies it
    });
  };

  /* ───────── cart (R6) ───────── */
  MetaSet.prototype.items = function (soloOnly) {
    var self = this;
    var out = [{ id: this.variant().id, quantity: 1 }];
    if (soloOnly) return out;
    this.slots.forEach(function (sc) {
      var sz = self.slotSize(sc);
      if (!sz) return;
      var it = { id: sz.id, quantity: 1 };
      if (self.sub && sz.sub) it.selling_plan = sz.sub.plan;
      out.push(it);
    });
    return out;
  };

  MetaSet.prototype.error = function (msg) {
    $$('[data-mlp-error], [data-mlp-sticky-error]', this.el).forEach(function (e) { e.hidden = !msg; e.textContent = msg || ''; });
    // the sticky bar grows when it carries the message — keep the body padding in step
    var bar = $('[data-mlp-sticky]', this.el);
    if (bar && !bar.hidden) { var h = bar.offsetHeight + 'px'; document.documentElement.style.setProperty('--aromely-sticky-h', h); var rootEl = this.el.closest('[data-mlp-root]'); if (rootEl) rootEl.style.setProperty('--sticky-h', h); }
  };

  MetaSet.prototype.add = function (soloOnly) {
    var self = this;
    if (this.busy) return;
    this.busy = true; this.error('');
    var btns = $$('[data-mlp-add], [data-mlp-sticky-add]', this.el);
    btns.forEach(function (b) { b.disabled = true; b.dataset.state = 'loading'; b.setAttribute('aria-busy', 'true'); });
    clarity('cta_tap', soloOnly ? 'solo' : 'set');
    var before;
    fetch(R.cart, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).catch(function () { return null; })
      .then(function (c) { before = c ? c.item_count : undefined;
        return fetch(R.add, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: self.items(soloOnly) }) });
      })
      .then(function (res) { return res.json().catch(function () { return {}; }).then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (r) {
        if (!r.ok || r.data.status) { throw new Error(r.data.description || r.data.message || 'Please try again'); }
        // make sure the code is on the cart so checkout opens discounted
        /* October Sale: the promotion code replaces FBSET10 while it runs. */
        var promoOn = !!(window.AromelyPromo && window.AromelyPromo.active && window.AromelyPromo.active());
        if (promoOn) {
          // Same hook the checkout buttons await, capped at 3 s so a slow reconcile never locks the button.
          var hook = window.AromelyPromo.beforeCheckout || window.AromelyPromo.reconcile;
          if (typeof hook !== 'function') return;
          return Promise.race([Promise.resolve().then(function () { return hook(); }), new Promise(function (resolve) { setTimeout(resolve, 3000); })])
            .catch(function () { /* the cart changed either way; the drawer re-renders from cart.js below */ });
        }
        if (self.code && !self.codeApplied) {
          return fetch(R.update, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: self.code }) }).catch(function () { /* checkout still works, just without the code pre-applied */ });
        }
      })
      .then(function () { return fetch(R.cart, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); })
      .then(function (cart) {
        if (cart && cart.discount_codes && cart.discount_codes.some(function (c) { return (c.code || '').toLowerCase() === self.code.toLowerCase() && c.applicable !== false; })) {
          self.codeApplied = true; var box = $('[data-mlp-code]', self.el); if (box) { box.dataset.state = 'on'; var t = $('[data-mlp-code-text]', box); if (t) t.textContent = '✓ ' + self.code + ' applied — nothing to type at checkout'; }
          self.paintTotals();
        }
        var ev = new Event('cart:update', { bubbles: true });
        ev.detail = { resource: cart, sourceId: self.el.id || 'aromely-meta-set', data: { source: 'aromely-meta-set', itemCount: cart && cart.item_count } };
        self.el.dispatchEvent(ev);
        clarity('cart_add', soloOnly ? 'solo' : 'set');
      })
      .catch(function (err) {
        fetch(R.cart, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
          if (c && before !== undefined && c.item_count !== before) self.error('We couldn’t confirm this with the store, but your cart did change — please check it before trying again.');
          else self.error('Couldn’t add this to your cart: ' + (err && err.message ? err.message : 'please try again') + '. Nothing was added.');
        }).catch(function () { self.error('We couldn’t reach the store — check your connection and try again.'); });
      })
      .then(function () { self.busy = false; btns.forEach(function (b) { b.disabled = false; b.dataset.state = ''; b.removeAttribute('aria-busy'); }); });
  };

  /* ───────── swap picker ───────── */
  MetaSet.prototype.openSwap = function (i) {
    var dlg = $('dialog[ref="swapDialog"]', this.el);
    if (!dlg) return;
    this.swapIdx = i;
    var current = this.slots[i];
    $$('.aromely-scent-picker__option', dlg).forEach(function (o) {
      var pid = parseInt(o.getAttribute('data-product-id'), 10);
      var on = !!(current && pid === current.product_id);
      if (on) o.setAttribute('data-selected', ''); else o.removeAttribute('data-selected');
      o.setAttribute('aria-pressed', String(on));
    });
    try { dlg.showModal(); } catch (e) { dlg.setAttribute('open', ''); }
    document.body.style.overflow = 'hidden';
    clarity('swap_open', String(i));
  };
  MetaSet.prototype.closeSwap = function () {
    var dlg = $('dialog[ref="swapDialog"]', this.el);
    if (!dlg) return;
    if (dlg.open) dlg.close(); else dlg.removeAttribute('open');
    document.body.style.overflow = '';
  };
  MetaSet.prototype.pickScent = function (pid) {
    var sc = this.scents.find(function (s) { return s.product_id === pid; });
    if (!sc || this.swapIdx == null) return;
    this.slots[this.swapIdx] = sc;
    this.paintSlot(this.swapIdx);
    this.paintSub();
    this.paintTotals();
    this.closeSwap();
  };

  /* ───────── details sheet (R8) ───────── */
  MetaSet.prototype.openSheet = function () {
    var d = this.model, dlg = $('[data-mlp-sheet]', this.el);
    if (!dlg) return;
    $('[data-sheet-name]', dlg).textContent = d.name;
    var gal = (d.gallery && d.gallery.length ? d.gallery : [d.hero]).filter(Boolean).slice(0, 8);
    $('[data-sheet-gal]', dlg).innerHTML = gal.map(function (u) { return '<img src="' + esc(u) + '" alt="" loading="lazy" decoding="async">'; }).join('');
    $('[data-sheet-rooms]', dlg).textContent = (d.rooms || ('Up to ' + d.coverage.toLocaleString() + ' sq ft')) + (d.hvac ? ' · connects to your HVAC air supply or runs standalone' : d.form_factor === 'plug-in' ? ' · plugs into the wall' : ' · freestanding, no HVAC connection needed');
    var specs = [
      ['Coverage', 'up to ' + d.coverage.toLocaleString() + ' sq ft'],
      ['Bottle inside', d.tank_ml + ' ml, refillable'],
      d.db ? ['Noise at max', 'about ' + d.db + ' dB'] : null,
      ['Control', 'Aromely app · schedule & intensity'],
      ['Warranty', '1 year · 30-day eligible returns'],
      ['Price', money(this.salePrice(this.variant().price), this.fmt)]
    ];
    $('[data-sheet-spec]', dlg).innerHTML = specs.filter(Boolean).map(function (s) { return '<div>' + esc(s[0]) + '<b>' + esc(s[1]) + '</b></div>'; }).join('');
    $('[data-sheet-how]', dlg).textContent = 'Cold-air diffusion: no heat, no water. Fragrance oil becomes a dry, ultra-fine mist that travels through the space. A full bottle lasts on average 1–3 months, depending on intensity and hours a day.';
    var revs = $('[data-sheet-revs]', dlg);
    revs.innerHTML = '<p class="mlp-revs__empty">Loading reviews…</p>';
    this.loadReviews(revs);
    try { dlg.showModal(); } catch (e) { dlg.setAttribute('open', ''); }
    clarity('sheet_open', d.key);
  };
  MetaSet.prototype.closeSheet = function () { var dlg = $('[data-mlp-sheet]', this.el); if (dlg) { if (dlg.open) dlg.close(); else dlg.removeAttribute('open'); } };

  /* ───────── reviews ───────── */
  MetaSet.prototype.lazyReviews = function () {
    var self = this, sec = $('#mlp-reviews', this.el.closest('[data-mlp-root]') || document);
    var target = $('[data-mlp-revs]', this.el);
    if (!target) return;
    var go = function () { if (self.reviewsVisible) return; self.reviewsVisible = true; self.loadReviews(target); };
    if ('IntersectionObserver' in window && sec) {
      var io = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { go(); io.disconnect(); } }, { rootMargin: '400px' });
      io.observe(sec);
      setTimeout(go, 6000);
    } else { setTimeout(go, 1500); }
  };
  MetaSet.prototype.loadReviews = function (target) {
    var self = this, d = this.model;
    if (!target || !this.proxy) return;
    var key = d.key;
    var render = function (list) {
      if (self.model.key !== key) return;
      if (!list || !list.length) { target.innerHTML = '<p class="mlp-revs__empty">No written reviews yet for this model — see the rating above.</p>'; return; }
      target.innerHTML = list.slice(0, 4).map(function (r) {
        var stars = '★★★★★'.slice(0, Math.max(0, Math.min(5, Math.round(r.rating || 0))));
        var body = (r.body || '').trim(); if (body.length > 240) body = body.slice(0, 237).replace(/\s+\S*$/, '') + '…';
        var pic = (r.has_published_pictures && r.pictures && r.pictures[0] && (r.pictures[0].urls || {}).compact) ? '<img src="' + esc(r.pictures[0].urls.compact) + '" alt="" loading="lazy">' : '';
        var ver = /buyer|purchase/i.test(r.verified || '') ? ' · Verified buyer' : '';
        var date = r.created_at ? new Date(r.created_at).toLocaleDateString('en-US', { month: 'short', year: 'numeric' }) : '';
        return '<article class="mlp-rev"><span class="mlp-rating__stars" aria-label="' + esc(r.rating) + ' stars">' + stars + '</span>' + (r.title ? '<b>' + esc(r.title) + '</b>' : '') + (body ? '<p>' + esc(body) + '</p>' : '') + pic + '<small>' + esc((r.reviewer && r.reviewer.name) || 'Aromely customer') + ver + (date ? ' · ' + date : '') + '</small></article>';
      }).join('');
    };
    if (this.reviewCache[key]) { render(this.reviewCache[key]); return; }
    this.resolveJm(d)
      .then(function (jm) {
        if (!jm.length) return [];
        return fetch(self.proxy + '/api/reviews?product_ids=' + jm.join(',') + '&per_page=4&page=1&rating_min=4').then(function (r) { return r.ok ? r.json() : null; }).then(function (x) { return (x && x.reviews) || []; });
      })
      .then(function (list) { self.reviewCache[key] = list; render(list); })
      .catch(function () { render([]); });
  };

  /* ───────── sticky (R6) ───────── */
  MetaSet.prototype.setupSticky = function () {
    var self = this, bar = $('[data-mlp-sticky]', this.el), btn = $('[data-mlp-add]', this.el), rootEl = this.el.closest('[data-mlp-root]');
    if (!bar || !btn) return;
    var atcVisible = true, drawerOpen = false;
    var show = function (on) { bar.hidden = !on; var h = on ? bar.offsetHeight + 'px' : '0px'; if (rootEl) rootEl.style.setProperty('--sticky-h', h); document.documentElement.style.setProperty('--aromely-sticky-h', h); };
    var measure = function () { var r = btn.getBoundingClientRect(); atcVisible = r.bottom > 0 && r.top < window.innerHeight; };
    var update = function () { show(!atcVisible && !drawerOpen); };
    window.addEventListener('scroll', function () { measure(); update(); }, { passive: true });
    window.addEventListener('resize', update);
    var dlg = document.querySelector('aromely-cart-drawer-component dialog, cart-drawer-component dialog');
    if (dlg && 'MutationObserver' in window) { drawerOpen = dlg.open; new MutationObserver(function () { drawerOpen = dlg.open; update(); }).observe(dlg, { attributes: true, attributeFilter: ['open'] }); }
    measure(); update();
  };

  /* ───────── capture (R12) ───────── */
  MetaSet.prototype.capture = function (form) {
    var self = this, email = (form.email.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { form.email.setAttribute('aria-invalid', 'true'); form.email.focus(); return; }
    var company = this.el.dataset.klaviyoCompany, list = this.el.dataset.klaviyoList;
    if (!company || !list) return;
    var btn = form.querySelector('button'); if (btn) btn.disabled = true;
    var t = this.totals();
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
      method: 'POST', headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: 'Meta landing page · ' + this.model.name, profile: { data: { type: 'profile', attributes: { email: email, properties: { lp_model: this.model.key, lp_set_total: (t.grand / 100).toFixed(2), lp_url: location.href } } } } }, relationships: { list: { data: { type: 'list', id: list } } } } })
    }).then(function (r) {
      if (!r.ok && r.status !== 202) throw new Error('subscribe failed');
      form.hidden = true; var ok = $('[data-mlp-cap-ok]', self.el); if (ok) ok.hidden = false;
      clarity('capture', 'email');
    }).catch(function () { if (btn) btn.disabled = false; form.email.setAttribute('aria-invalid', 'true'); });
  };

  /* ───────── video ───────── */
  MetaSet.prototype.playVideo = function () {
    var d = this.model, stage = $('[data-mlp-stage]', this.el), img = $('.mlp-hero-img', this.el), play = $('[data-mlp-play]', this.el);
    if (!d.video || !stage) return;
    var v = document.createElement('video');
    v.src = d.video; v.controls = true; v.playsInline = true; v.preload = 'metadata'; v.poster = d.hero || '';
    // starts muted (also lets it play without a browser block); one tap on the pill or the native control turns sound on
    v.muted = true; v.setAttribute('muted', ''); v.setAttribute('playsinline', '');
    if (img) img.hidden = true;
    if (play) play.hidden = true;
    stage.appendChild(v);
    var snd = document.createElement('button');
    snd.type = 'button'; snd.className = 'mlp-stage__sound'; snd.setAttribute('aria-pressed', 'false');
    snd.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 5 6 9H2v6h4l5 4V5z"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/></svg> Tap for sound';
    var paintSound = function () { var on = !v.muted; snd.setAttribute('aria-pressed', String(on)); snd.innerHTML = on ? '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 5 6 9H2v6h4l5 4V5z"/><path d="M15.5 8.5a5 5 0 0 1 0 7"/><path d="M19 5a10 10 0 0 1 0 14"/></svg> Sound on' : '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 5 6 9H2v6h4l5 4V5z"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/></svg> Tap for sound'; };
    snd.addEventListener('click', function (e) { e.stopPropagation(); v.muted = !v.muted; if (!v.muted) v.volume = 1; paintSound(); clarity('video_sound', v.muted ? 'off' : 'on'); });
    v.addEventListener('volumechange', paintSound);
    stage.appendChild(snd);
    var p = v.play(); if (p && p.catch) p.catch(function () { /* user can tap play */ });
    clarity('video_play', d.key);
  };

  /* ───────── events ───────── */
  MetaSet.prototype.bind = function () {
    var self = this, el = this.el;
    el.addEventListener('click', function (e) {
      var t = e.target;
      var b;
      if ((b = t.closest('[data-mlp-v]'))) { self.setVariant(parseInt(b.getAttribute('data-mlp-v'), 10) || 0); return; }
      if ((b = t.closest('[data-mlp-swap]'))) { self.openSwap(parseInt(b.getAttribute('data-mlp-swap'), 10) || 0); return; }
      if ((b = t.closest('[data-mlp-card]'))) { self.openSheet(); return; }
      if ((b = t.closest('[data-mlp-rating-btn]'))) { var s = $('#mlp-reviews'); if (s) s.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
      if ((b = t.closest('[data-mlp-fit-opt]'))) { self.answerFit(b.getAttribute('data-mlp-fit-opt'), null, false); return; }
      if ((b = t.closest('[data-mlp-hvac-opt]'))) { self.answerFit('home', b.getAttribute('data-mlp-hvac-opt'), false); return; }
      if ((b = t.closest('[data-mlp-model]'))) { var mk = b.getAttribute('data-mlp-model'); var md = self.diffusers.find(function (x) { return x.key === mk; }); if (md && md !== self.model) { self.setModel(md, true); if (self.fitByUser) self.answerFit(self.fit, self.hvac, true); else self.preAnswerFit(); clarity('model_pick', mk); } return; }
      if ((b = t.closest('[data-mlp-switch]'))) { var key = b.getAttribute('data-mlp-switch'); var d = self.diffusers.find(function (x) { return x.key === key; }); if (d) { self.setModel(d, true); clarity('step_down', 'taken'); var form = $('[data-mlp-form]', el); if (form) form.scrollIntoView({ behavior: 'smooth', block: 'start' }); self.answerFit(self.fit, self.hvac, true); } return; }
      if ((b = t.closest('[data-mlp-apply]'))) { self.applyCode(); return; }
      if ((b = t.closest('[data-mlp-solo]'))) { self.add(true); return; }
      if ((b = t.closest('[data-mlp-sticky-add]'))) { self.add(false); return; }
      if ((b = t.closest('[data-mlp-play]'))) { self.playVideo(); return; }
      if ((b = t.closest('[data-sheet-close]')) || (b = t.closest('[data-sheet-use]'))) { self.closeSheet(); return; }
      if ((b = t.closest('.aromely-scent-picker__option'))) { self.pickScent(parseInt(b.getAttribute('data-product-id'), 10)); return; }
      if ((b = t.closest('[on\\:click="/closeSwapDialog"]')) || (b = t.closest('[on\\:click="/confirmSelection"]'))) { self.closeSwap(); return; }
      // backdrop clicks
      if (t.matches && t.matches('dialog[ref="swapDialog"]')) { self.closeSwap(); return; }
      if (t.matches && t.matches('[data-mlp-sheet]')) { self.closeSheet(); return; }
    });
    // the picker's options are role=button divs; the theme component that handled their keydown does not run on this page
    el.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
      var o = e.target.closest && e.target.closest('.aromely-scent-picker__option');
      if (!o || e.target.closest('select, input, a, button')) return;
      e.preventDefault();
      self.pickScent(parseInt(o.getAttribute('data-product-id'), 10));
    });
    var form = $('[data-mlp-form]', el);
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); self.add(false); });
    var sub = $('[data-mlp-sub]', el);
    if (sub) sub.addEventListener('change', function () { self.sub = sub.checked; self.paintTotals(); clarity('subscribe_toggle', sub.checked ? 'on' : 'off'); });
    var cap = $('[data-mlp-cap-form]', el);
    if (cap) cap.addEventListener('submit', function (e) { e.preventDefault(); self.capture(cap); });
    $$('dialog', el).forEach(function (d) { d.addEventListener('close', function () { document.body.style.overflow = ''; }); });
  };

  function boot() {
    $$('aromely-meta-set').forEach(function (el) { if (!el.__mlp) el.__mlp = new MetaSet(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
